import { render, staticRenderFns } from "./CaixaUser.vue?vue&type=template&id=b35fe5fa"
import script from "./CaixaUser.vue?vue&type=script&lang=js"
export * from "./CaixaUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports